import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocCaseSearch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M84.571 100.5C90.883 100.5 96 95.383 96 89.071H38.857c0 6.312-5.117 11.429-11.428 11.429H84.57Z"
        fill="#E2E8F0"
      />
      <path
        d="M27.429 100.5C21.117 100.5 16 95.383 16 89.071V20.5h57.143v68.571c0 6.312 5.117 11.429 11.428 11.429H27.43Z"
        fill="#F1F5F9"
      />
      <path
        d="M72.343 89.071c0 6.754 5.475 12.229 12.229 12.229a.8.8 0 0 0 0-1.6c-5.87 0-10.63-4.759-10.63-10.629a.8.8 0 0 0-1.599 0Z"
        fill="#0F172A"
      />
      <path
        d="M31.532 37.936a2.508 2.508 0 0 0-3.32.768l-.089.143a3.747 3.747 0 0 0-.012.02l-4.004 6.888-.117.228a2.484 2.484 0 0 0 1.032 3.175c1.193.684 2.72.28 3.412-.91l1.852-3.187 1.852 3.187a2.505 2.505 0 0 0 3.41.91 2.483 2.483 0 0 0 .916-3.403l-4.003-6.887-.013-.02-.089-.143a2.488 2.488 0 0 0-.827-.769Zm3.548 8.623a.883.883 0 0 1-.328 1.211.904.904 0 0 1-1.23-.326l-2.31-3.976 1.036-1.783 2.832 4.874Zm-5.72-3.09-2.31 3.975a.904.904 0 0 1-1.23.326.883.883 0 0 1-.329-1.21l2.833-4.875 1.036 1.783Zm.474-4.143a.906.906 0 0 1 .902-.001h.001a.887.887 0 0 1 .328 1.21l-.779 1.342-.78-1.341a.88.88 0 0 1 0-.886v-.001a.885.885 0 0 1 .328-.323Z"
        fill="#78B441"
      />
      <path
        d="M24.571 78.747a.8.8 0 0 0 0 1.601h40a.8.8 0 0 0 0-1.6h-40Zm0-5.713a.8.8 0 1 0 0 1.6h40a.8.8 0 1 0 0-1.6h-40Zm0-5.715a.8.8 0 0 0 0 1.6h40a.8.8 0 0 0 0-1.6h-40Zm0-5.714a.8.8 0 1 0 0 1.6h40a.8.8 0 1 0 0-1.6h-40Zm0-5.714a.8.8 0 1 0 0 1.6h40a.8.8 0 0 0 0-1.6h-40Zm17.143-5.715a.8.8 0 0 0 0 1.6H64.57a.8.8 0 1 0 0-1.6H41.714Zm0-5.714a.8.8 0 0 0 0 1.6H64.57a.8.8 0 1 0 0-1.6H41.714Zm0-5.715a.8.8 0 0 0 0 1.601H64.57a.8.8 0 0 0 0-1.6H41.714Zm0-5.714a.8.8 0 0 0 0 1.6H64.57a.8.8 0 1 0 0-1.6H41.714Z"
        fill="#B3C0D0"
      />
      <path
        d="m83.364 53.526 18.516 15.438a4.085 4.085 0 1 1-5.473 6.054L79.184 58.15l4.18-4.624Z"
        fill="#007A5F"
      />
      <path d="m89.183 58.378.55 10.104-10.55-10.332 4.18-4.624 5.82 4.852Z" fill="#00664F" />
      <path
        d="m89.184 58.378.549 10.104-10.55-10.332 4.18-4.624 5.82 4.852Zm-7.784-.296 6.511 6.376-.288-5.298-4.103-3.421-2.12 2.343Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.257 63.114c8.358 4.28 18.602.973 22.88-7.385 4.28-8.357.973-18.602-7.385-22.881-8.357-4.28-18.601-.973-22.88 7.385-4.28 8.358-.973 18.602 7.385 22.881Z"
        fill="#78B441"
      />
      <path
        d="M85.469 48.26c0 6.73-5.455 12.185-12.184 12.185-6.73 0-12.185-5.455-12.185-12.184 0-6.73 5.455-12.184 12.184-12.184 6.73 0 12.185 5.455 12.185 12.184Z"
        fill="#CAE8DF"
      />
      <path
        d="M63.134 48.26c0-5.605 4.545-10.15 10.15-10.15a.8.8 0 1 1 0 1.6 8.55 8.55 0 0 0-8.55 8.55.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M60.3 48.261c0-7.17 5.814-12.984 12.985-12.984a.8.8 0 0 1 0 1.6c-6.288 0-11.385 5.097-11.385 11.384s5.098 11.384 11.385 11.384a.8.8 0 0 1 0 1.6c-7.171 0-12.984-5.813-12.985-12.984Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocCaseSearch)
